import CachedIcon from "mdi-react/CachedIcon";
import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Dropdown, Badge } from "react-bootstrap";
import TableComponent from "../TableComponent";
import {
  ApproveBlueModalIcon,
  EditIcon,
  FIleUploadLineIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  LoaderIcon,
  ViewIcon,
} from "../Icons";
import { useLocalStorage, useQueryParams } from "../../utils/hooks";
import useDebounce from "../../utils/hooks";
import { useMutation, useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import queryString from "query-string";
import {
  formatDate,
  paginationOptions,
  fetchActionsUtil,
  getCurrencySymbol,
} from "../../utils/helpers";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ReactPaginate from "react-paginate";
import NoTableItem from "../utils/NoTableItem";
import { isEmpty, truncate } from "lodash";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import currency from "currency.js";
import { MdUploadFile } from "react-icons/md";
import UploadCertificateModal from "./UploadCertificateModal";
import ViewParticipantCertificateModal from "./ViewParticipantCertificateModal";
import UpdateCertificateModal from "./UpdateCertificateModal";
import ConfirmDialog from "../ConfirmDialogue";
import NewCustomerRequisition from "../Requisition/NewCustomerRequisition";
import ParticipantsSelectionModal from "./ParticipantsSelectionModal";
import EnrollmentDetailsModal from "./EnrollmentDetailsModal";

function Enrollment() {
  const navMetaData = useOutletContext();
  const { backendUrl, token } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage(
    "showEnrollmentFilter",
    true,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [enrollments, setEnrollments] = useState([]);
  const [courses, setCourses] = useState([]);
  const [statusOptions] = useState([
    { value: "Enrolled", label: "Enrolled" },
    { value: "Completed", label: "Completed" },
    { value: "Certificate Issued", label: "Certificate Issued" },
  ]);

  const [showUploadCertificateModal, setShowUploadCertificateModal] = useState(
    false,
  );
  const [showViewCertificateModal, setShowViewCertificateModal] = useState(
    false,
  );
  const [showUpdateCertificateModal, setShowUpdateCertificateModal] = useState(
    false,
  );
  const [selectedEnrollmentId, setSelectedEnrollmentId] = useState(null);

  const [showNewRequisitionModal, setShowNewRequisitionModal] = useState(false);
  const [newRequisition, setNewRequisition] = useState({});

  const [showParticipantModal, setShowParticipantModal] = useState(false);
  const [showEnrollmentDetailsModal, setShowEnrollmentDetailsModal] = useState(
    false,
  );
  const [
    selectedEnrollmentForDetails,
    setSelectedEnrollmentForDetails,
  ] = useState(null);
  const [isCourseCompleted, setIsCourseCompleted] = useState(false);

  const initialFilterParams = {
    course_id: "",
    status: "",
    searchQuery: "",
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);

  const fetchEnrollments = async (query) => {
    try {
      const data = await fetchActionsUtil(
        `${backendUrl}/api/partnership/course-enrollments?${queryString.stringify(
          query,
        )}`,
        "GET",
        token,
      );
      return data;
    } catch (error) {
      toast.error("Error getting enrollments, please refresh the page");
      throw error;
    }
  };

  // Sync debounced filter params with query params
  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_ENROLLMENTS", queryParams],
    () => fetchEnrollments(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
      onSuccess: (responseData) => {
        setEnrollments(
          responseData.data || responseData.enrollments || responseData,
        );

        if (responseData) {
          navMetaData({
            stat1: {
              value: responseData?.totalEnrollment || 0,
              label: "Total Enrollments",
            },
            stat2: {
              value: responseData?.completedCount || 0,
              label: "Completed & Approved",
            },
            stat3: {
              value: responseData?.enrolledCount || 0,
              label: "Enrolled",
            },
          });
        }
      },
    },
  );

  // Fetch courses for filter dropdown
  useQuery(
    ["GET_COURSES_FOR_FILTER"],
    async () => {
      const data = await fetchActionsUtil(
        `${backendUrl}/api/partnership/courses`,
        "GET",
        token,
      );
      return (data.data || data || []).map((course) => ({
        value: course.id,
        label: course.title,
      }));
    },
    {
      enabled: true,
      keepPreviousData: true,
      onSuccess: (courses) => {
        setCourses(courses);
      },
      onError: (error) => {
        console.log("Error fetching courses:", error);
      },
    },
  );

  const markAsCompleted = async (enrollmentId, participants) => {
    if (
      await ConfirmDialog({
        title: `Course Completion Approval Request - ${
          selectedEnrollmentForDetails?.course?.title
        }`,
        description:
          "This will initiate an approval request. The enrollment will only be marked as completed upon approval.",
        type: "warning",
      })
    ) {
      setNewRequisition({
        title: `Course Completion Approval Request - ${
          selectedEnrollmentForDetails?.course?.title
        }`,
        description: `This will initiate an approval request. The enrollment will only be marked as completed upon approval. Participants to be approve for are: ${participants
          .map((p) => p.name)
          .join(", ")}.`,
        type: "Course Completion",
        cost: 0,
        vendor: ``,
        loanDetails: { enrollmentId, participants },
        Cust_ID: "",
      });

      setShowNewRequisitionModal(true);

      // updateEnrollmentStatusMutation.mutate({
      //   enrollmentId,
      //   status: "Completed",
      // });
    }
  };

  const handleFilterParamsChange = (e) => {
    const { name, value } = e.target;
    setFilterParams({
      ...filterParams,
      [name]: value,
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const getStatusBadge = (status) => {
    const variant =
      status === "Completed"
        ? "success"
        : status === "Enrolled"
        ? "primary"
        : "info";
    return <Badge bg={variant}>{status}</Badge>;
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>Course</th>
          <th>Participant Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Company</th>
          <th>Department</th>
          <th>Job Title</th>
          <th>Status</th>
          <th>Total Participants</th>
          <th>Price</th>
          <th>Enrolled At</th>
          <th>Completed At</th>
          <th>Actions</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{truncate(el?.course?.title || "...", { length: 20 })}</td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 1 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                .map((participant) => (
                  <div className=" mb-3">{participant?.full_name || "-"}</div>
                ))}
              {el?.participants?.length > 3 && (
                <Button
                  variant="primary"
                  size="sm"
                  className="mt-1 fst-italic"
                  onClick={() => {
                    setSelectedEnrollmentForDetails(el);
                    setShowEnrollmentDetailsModal(true);
                  }}
                >
                  Show More ({el?.participants?.length - 3})
                </Button>
              )}
            </>
          ) : (
            el?.full_name || "-"
          )}{" "}
        </td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 1 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                .map((participant) => (
                  <div className=" mb-3">{participant?.email || "-"}</div>
                ))}
            </>
          ) : (
            el?.email || "-"
          )}{" "}
        </td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 1 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                ?.map((participant) => (
                  <div className=" mb-3">{participant?.phone || "-"}</div>
                ))}
            </>
          ) : (
            el?.phone || "-"
          )}{" "}
        </td>
        <td>{truncate(el?.company_name, { length: 15 }) || "-"}</td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 1 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                ?.map((participant) => (
                  <div className=" mb-3">{participant?.department || "-"}</div>
                ))}
            </>
          ) : (
            el?.department || "-"
          )}{" "}
        </td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 1 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                ?.map((participant) => (
                  <div className=" mb-3">{participant?.job_title || "-"}</div>
                ))}
            </>
          ) : (
            el?.job_title || "-"
          )}{" "}
        </td>
        <td>
          {" "}
          {!isEmpty(el?.participants) && el?.participants?.length > 0 ? (
            <>
              {el?.participants
                ?.slice(0, 3)
                ?.map((participant) => (
                  <div className=" mb-3">
                    {getStatusBadge(participant?.course_enrollment_status) ||
                      "-"}
                  </div>
                ))}
            </>
          ) : (
            el?.status || "-"
          )}{" "}
        </td>
        <td className="text-center">{el?.total_participants || 0}</td>
        <td>
          {currency(el?.total_price).format({
            symbol: getCurrencySymbol(el?.course?.currency),
            separator: ",",
          })}
        </td>
        <td>{el?.enrolled_at ? formatDate(el.enrolled_at) : "-"}</td>
        <td>{el?.completed_at ? formatDate(el.completed_at) : "-"}</td>
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon size={20} />
            </Dropdown.Toggle>

            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as={"button"}
                onClick={() => {
                  setSelectedEnrollmentForDetails(el);
                  setShowEnrollmentDetailsModal(true);
                }}
              >
                <ViewIcon /> View Course Details
              </Dropdown.Item>
              <Dropdown.Item
                as={"button"}
                onClick={() => {
                  setSelectedEnrollmentId(el?.id);
                  setShowViewCertificateModal(true);
                }}
              >
                <ViewIcon /> View Certificates
              </Dropdown.Item>

              {el?.status === "Completed" &&
                !isEmpty(el?.participants) &&
                el?.participants?.some((part) =>
                  ["completed"].includes(
                    part?.course_enrollment_status?.toLowerCase(),
                  ),
                ) && (
                  <Dropdown.Item
                    as={"button"}
                    onClick={() => {
                      setSelectedEnrollmentId(el?.id);
                      setShowUploadCertificateModal(true);
                    }}
                  >
                    <FIleUploadLineIcon /> Upload Certificates
                  </Dropdown.Item>
                )}

              {el?.status === "Completed" &&
                !isEmpty(el?.participants) &&
                el?.participants?.some((part) =>
                  ["completed", "certificate issued"].includes(
                    part?.course_enrollment_status?.toLowerCase(),
                  ),
                ) && (
                  <Dropdown.Item
                    as={"button"}
                    onClick={() => {
                      setSelectedEnrollmentId(el?.id);
                      setShowUpdateCertificateModal(true);
                    }}
                  >
                    <EditIcon /> Update Certificates
                  </Dropdown.Item>
                )}

              <Dropdown.Item
                as={"button"}
                onClick={() => {
                  setIsCourseCompleted(true);
                  setSelectedEnrollmentId(el?.id);
                  setSelectedEnrollmentForDetails(el);

                  setShowParticipantModal(true);
                }}
              >
                <ApproveBlueModalIcon width={"16px"} height={"16px"} />
                Mark as Completed
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </>
    );
  };

  return (
    <>
      <main className="cash-book">
        <div className="content">
          <div className="content-main pt-3">
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <FilterTwoIcon /> Filters
                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body">
                <Form>
                  <div className="body">
                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Search (Name or Email)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="searchQuery"
                          value={filterParams.searchQuery}
                          placeholder="Search by name or email"
                          onChange={handleFilterParamsChange}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Course</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Select course"
                        name="course_id"
                        value={courses.find(
                          (course) =>
                            course.value === Number(filterParams.course_id),
                        )}
                        onChange={(e) => {
                          setFilterParams({
                            ...filterParams,
                            course_id: e?.value || "",
                          });
                        }}
                        options={courses}
                        isClearable
                      />
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Status</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Select status"
                        name="status"
                        value={statusOptions.find(
                          (status) => status.value === filterParams.status,
                        )}
                        onChange={(e) => {
                          setFilterParams({
                            ...filterParams,
                            status: e?.value || "",
                          });
                        }}
                        options={statusOptions}
                        isClearable
                      />
                    </Form.Group>

                    <hr className="mt-3 mb-4" />
                  </div>

                  <div className="buttons rounded">
                    <Button onClick={reset} variant="white">
                      Reset
                    </Button>
                    <Button onClick={search} variant="primary">
                      Search
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon />
                    </button>
                  )}
                  Enrollments Management
                  <button
                    title="Refresh"
                    className="btn text-primary"
                    onClick={() => {
                      refetch();
                    }}
                  >
                    <CachedIcon />
                  </button>
                </h1>
              </header>

              <div className="m-3">
                <TableComponent
                  responsive
                  borderless
                  striped
                  tableHeadsFunction={tableHead}
                  mainDataArray={enrollments || []}
                  className="product-table text-nowrap"
                  tableDataRowFunction={tableData}
                />

                {!isFetching && isSuccess && isEmpty(enrollments) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select"
                    onChange={(e) => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data?.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </main>

      {isLoading && (
        <div className="global-spinner">
          <LoaderIcon className="spin text-primary" />
        </div>
      )}

      {showUploadCertificateModal && (
        <UploadCertificateModal
          show={showUploadCertificateModal}
          onHide={() => {
            setShowUploadCertificateModal(false);
            setSelectedEnrollmentId(null);
          }}
          onSuccess={() => {
            refetch();
            setShowUploadCertificateModal(false);
            setSelectedEnrollmentId(null);
          }}
          enrollmentId={selectedEnrollmentId}
          mode="create"
        />
      )}

      {showViewCertificateModal && (
        <ViewParticipantCertificateModal
          show={showViewCertificateModal}
          onHide={() => {
            setShowViewCertificateModal(false);
            setSelectedEnrollmentId(null);
          }}
          enrollmentId={selectedEnrollmentId}
        />
      )}

      {showUpdateCertificateModal && (
        <UpdateCertificateModal
          show={showUpdateCertificateModal}
          onHide={() => {
            setShowUpdateCertificateModal(false);
            setSelectedEnrollmentId(null);
          }}
          onSuccess={() => {
            refetch();
            setShowUpdateCertificateModal(false);
            setSelectedEnrollmentId(null);
          }}
          enrollmentId={selectedEnrollmentId}
        />
      )}

      {showNewRequisitionModal && (
        <NewCustomerRequisition
          modalTitle="Send for Approval"
          defaultFormValues={{
            title: newRequisition.title,
            description: newRequisition.description,
            type: newRequisition.type,
            cost: newRequisition.cost,
            vendor: newRequisition.vendor,
            loanDetails: JSON.stringify(newRequisition?.loanDetails),
          }}
          Cust_ID={newRequisition.Cust_ID}
          setShowNewRequisitionModal={setShowNewRequisitionModal}
          handleCreatedRequisition={() => {}}
          refetch={refetch}
        />
      )}

      {showParticipantModal && (
        <ParticipantsSelectionModal
          show={showParticipantModal}
          onHide={() => {
            setShowParticipantModal(false);
            setSelectedEnrollmentId(null);
          }}
          onSuccess={(selectedParticipants) => {
            markAsCompleted(selectedEnrollmentId, selectedParticipants);

            setShowParticipantModal(false);
            setSelectedEnrollmentId(null);
          }}
          enrollmentId={selectedEnrollmentId}
        />
      )}

      {showEnrollmentDetailsModal && (
        <EnrollmentDetailsModal
          show={showEnrollmentDetailsModal}
          onHide={() => {
            setShowEnrollmentDetailsModal(false);
            setSelectedEnrollmentForDetails(null);
          }}
          enrollment={selectedEnrollmentForDetails}
        />
      )}
    </>
  );
}

export default Enrollment;
